module.exports = __webpack_public_path__ + "static/media/bursts_24.64057879.svg";